var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { prevent } from '../../../../common/utils';
import { styles } from '../input.styles';
export var InputSlotPanel = function (_a) {
    var panel = _a.panel, panelLabel = _a.panelLabel, panelContent = _a.panelContent;
    if (!panel)
        return null;
    return _jsx(_Fragment, { children: _jsxs("div", __assign({ className: styles.slotPanel, onClick: prevent }, { children: [panelLabel, panelContent] })) });
};
